import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F2C856",
      d: "M12.552 1.394 9.256 7.858l-7.373 1.04C.56 9.083.03 10.66.99 11.563l5.334 5.03-1.262 7.103c-.227 1.284 1.171 2.246 2.342 1.645L14 21.987l6.596 3.354c1.17.596 2.569-.361 2.342-1.645l-1.262-7.104 5.334-5.028c.96-.904.43-2.48-.893-2.666l-7.373-1.04-3.296-6.464c-.59-1.152-2.3-1.167-2.896 0"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "star-full"}) } }